var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qa-print__phases"},[_c('Card',{staticClass:"qa-print__phase",attrs:{"data-testid":"qa-print-before","title":_vm.$t('quick_action.phases.before')}},[_c('template',{slot:"content"},[_c('EvidenceSection',{attrs:{"imageTestId":"before_photo","imageHeight":"200","mediaObject":_vm.before.media,"questions":[
          {
            text: _vm.$t('quick_action.before.whats_the_problem'),
            answer: _vm.before.situation,
            tid: 'before-problem',
          },
          {
            text: _vm.$t('quick_action.before.type_of_situation'),
            answer: _vm.before.situationTypes,
            tid: 'before-situation-type',
          },
        ]}})],1)],2),_c('Card',{staticClass:"qa-print__phase",attrs:{"data-testid":"qa-print-after","title":_vm.$t('quick_action.phases.after')}},[_c('template',{slot:"content"},[_c('EvidenceSection',{attrs:{"imageTestId":"after_photo","imageHeight":"200","mediaObject":_vm.after.media,"questions":[
          {
            text: _vm.$t('quick_action.after.what_did_you_do'),
            answer: _vm.after.solution,
            tid: 'after-solution',
          },
          {
            text: _vm.$t('quick_action.after.suggested_tags'),
            answer: _vm.after.suggestedTags,
            tid: 'after-suggested-tags',
          },
        ]}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }